<div class="modal-header">
  <h5 class="modal-title">Select Address</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body p-3">
  <!-- Show address list if exists -->
  <div *ngIf="addresses?.length; else noAddressList">
    <div
      *ngFor="let addr of addresses"
      (click)="selectedAddress = addr"
      [class.selected]="selectedAddress === addr"
      class="address-option"
    >
      <input
        type="checkbox"
        [checked]="selectedAddress === addr"
        (click)="$event.stopPropagation(); selectedAddress = addr"
      />
      <div class="address-content">
        <p class="address-name">{{ addr.name }}</p>
        <p class="address-line">{{ addr.address }},{{ addr.city }}, {{ addr.state }}, {{ addr.zipcode }}  </p>

      </div>
    </div>
  </div>

  <!-- Shown when no address available -->
  <ng-template #noAddressList>
    <div class="empty-state">
      <p>No pickup addresses found.</p>
    </div>
  </ng-template>

  <!-- <div class="add-address-button mt-3">
    <button class="btn btn-success w-100" (click)="addAddress()">Add Address</button>
  </div> -->
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!selectedAddress" (click)="confirmSelection()">
    Confirm
  </button>
</div>
